






















































export default {
  name: 'DotsIcon',
  props: {
    color: {
      type: String,
      default: '#B6BEC7' // Default color if not provided
    }
  }
}
